module.exports = __webpack_public_path__ + "img/weavr-login-img.4b2b4130.svg";